import * as Sentry from '@sentry/react'
import React from 'react'
import { Footer } from '../shared/components/Footer'
import { Header } from './components/Header'
import { Content } from './page/Content'
function FallbackComponent() {
  return <div>An error has occured</div>
}

export const App: React.FC = () => {
  return (
    <Sentry.ErrorBoundary fallback={FallbackComponent} showDialog>
      <Header />
      <Content />
      <Footer />
    </Sentry.ErrorBoundary>
  )
}
